import React from 'react';
import { cn } from '@/helpers/classnames';
import { createIcon } from './createIcon';
import { ContainedIcon, ContainedIconProps } from './ContainedIcon';

const Glyph = createIcon(
  'InventoryGlyph',
  <>
    <path
      d="M3.5 5.5L5 7L7.5 4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 11.5L5 13L7.5 10.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 17.5L5 19L7.5 16.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 6L20 6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 12H20" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 18H20" strokeLinecap="round" strokeLinejoin="round" />
  </>,
);

const Inventory: React.FC<ContainedIconProps> = ({
  className,
  circleClassName,
}) => (
  <ContainedIcon circleClassName={circleClassName}>
    <Glyph className={cn(circleClassName && 'size-4', className)} />
  </ContainedIcon>
);

export default Inventory;
